/**
 * GamifCelebration · Temporada 1
 *
 * Escucha "gamif:level-up" y "gamif:badge-earned" (disparados por
 * useGamifEvents.js) y responde con confetti + un banner arriba de todo.
 * Mismo patrón visual que XpToast — global, montado una vez en Layout.
 */
import { useEffect, useState } from "react";
import confetti from "canvas-confetti";

function celebrate(colors) {
  const fire = (opts) => confetti({ particleCount: 80, spread: 70, origin: { y: 0.55 }, colors, ...opts });
  fire({ angle: 60, origin: { x: 0 } });
  fire({ angle: 120, origin: { x: 1 } });
  setTimeout(() => fire({ particleCount: 130, spread: 100 }), 200);
}

export default function GamifCelebration() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    const onLevelUp = (e) => {
      const nivel = e.detail?.nivel;
      if (!nivel) return;
      celebrate([nivel.color, "#EF9F27", "#ffffff"]);
      setBanner({ title: `¡Subiste a ${nivel.nombre}!`, sub: `Nivel ${nivel.nivel}`, color: nivel.color });
      setTimeout(() => setBanner(null), 4500);
    };
    const onBadge = (e) => {
      const badge = e.detail?.badge;
      if (!badge) return;
      celebrate([badge.color || "#7F77DD", "#EF9F27", "#ffffff"]);
      setBanner({ title: "¡Badge nuevo!", sub: `${badge.nombre} · ${badge.tier}`, color: badge.color || "#7F77DD" });
      setTimeout(() => setBanner(null), 4500);
    };
    window.addEventListener("gamif:level-up", onLevelUp);
    window.addEventListener("gamif:badge-earned", onBadge);
    return () => {
      window.removeEventListener("gamif:level-up", onLevelUp);
      window.removeEventListener("gamif:badge-earned", onBadge);
    };
  }, []);

  if (!banner) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-6 z-[9999] flex justify-center">
      <div
        className="pointer-events-auto px-6 py-3 rounded-2xl shadow-2xl border text-white text-center"
        style={{
          background: `linear-gradient(135deg, ${banner.color}, ${banner.color}cc)`,
          borderColor: banner.color,
          animation: "gamifCelebrationPop 4.5s ease-out forwards",
        }}
      >
        <div className="text-lg font-bold">{banner.title}</div>
        <div className="text-xs opacity-90 font-medium">{banner.sub}</div>
      </div>
      <style>{`
        @keyframes gamifCelebrationPop {
          0%   { opacity: 0; transform: translateY(-20px) scale(0.9); }
          10%  { opacity: 1; transform: translateY(0) scale(1.05); }
          20%  { transform: translateY(0) scale(1); }
          85%  { opacity: 1; }
          100% { opacity: 0; transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
}
